import React, { useState } from "react";
import { Media } from "reactstrap";
import { mldInvest } from "../../../../src/waitlist/assets/constants/mld-invest";
import VideoModal from "../../components/VideoModal";

const MldRisk = (props) => {
  const [showVideo, setShowVideo] = useState(false);

  const handlelearnCLick = () => {
    toggleVideoModal();
  };

  const toggleVideoModal = () => {
    setShowVideo(!showVideo);
  };

  return (
    <div className="mld-third-fold mb-5">
      <p className="mld-fold-three-title text-center">
        {mldInvest.riskFold.title}
      </p>
      {/* <p onClick={() => handlelearnCLick("")} className="learnmore">Watch the video to understand about risks <span class="mdi mdi-play-circle"></span></p> */}

      {props?.mldAssetDetails?.bondId === "mld3" ? (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "RiskTable.webp"
                : process.env.REACT_APP_IMAGES_PATH + "RiskTableMobile.webp"
            }
            alt="mld-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      ) : props?.mldAssetDetails?.bondId === "mld4" ? (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "1.5x_MLD_Table.webp"
                : process.env.REACT_APP_IMAGES_PATH + "risk-table-bidd.webp"
            }
            alt="mld-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      ) : props?.mldAssetDetails?.bondId === "mld5" ? (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "risksInvolvedmld5.webp"
                : process.env.REACT_APP_IMAGES_PATH + "risksInvolvedMobmld5.webp"
            }
            alt="mld-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      ) : props?.mldAssetDetails?.bondId === "gmldm0" ? (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Table.webp"
                : process.env.REACT_APP_IMAGES_PATH + "Table+Mobile.webp"
            }
            alt="gmldm0-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      ) : props?.mldAssetDetails?.bondId === "gmld1" ? (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "Desktop+Table.jpg"
                : process.env.REACT_APP_IMAGES_PATH + "Mobile_Table.jpg"
            }
            alt="gmld1-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      ) : (
        <div className="img-container">
          <Media
            src={
              !props.isMobile
                ? process.env.REACT_APP_IMAGES_PATH + "riskTableSpan0.webp"
                : process.env.REACT_APP_IMAGES_PATH + "riskTableSpan0Mob.webp"
            }
            alt="mld-return"
            className="cards-img"
            style={{ maxWidth: "100%" }}
          />
        </div>
      )}

      <VideoModal showVideo={showVideo} toggleVideoModal={toggleVideoModal} />
    </div>
  );
};

export default MldRisk;
